import styled from 'styled-components';
import { roundnessCalculator } from '../../../../components/DesignSystem/AtomicComponents/util';
import { hexToRgba } from '../../../../components/DesignSystem/ModernTheme/utils/common';

const borderColorAttributes = (isAvailable, isSelected, storeInfo) => {
  if (!isAvailable) {
    return isSelected ? '#B2B2B2' : `#F0F0F0`;
  } else if (isSelected) {
    return `${storeInfo?.theme?.colors?.primary_color}`;
  } else {
    return '#D5D5D5';
  }
};

const variantTextColor = (props) => {
  if (!props?.isAvailable) {
    return '#9A9A9A';
  }
  if (props?.isSelected) {
    return props?.storeInfo?.theme?.colors?.primary_color;
  }
  return '#000000';
};

const variantBackgroundColor = (props) => {
  if (!props?.isAvailable) {
    return '#F0F0F0';
  }
  if (props?.isSelected) {
    return hexToRgba(props?.storeInfo?.theme?.colors?.primary_color, 0.05);
  }
  return '#FFFFFF';
};

const hoveredBorderState = (props) => {
  if (!props?.isAvailable) {
    return props?.isSelected ? '1px solid #B2B2B2' : `1px solid #F0F0F0`;
  } else if (props.isSelected) {
    return `1px solid ${props?.storeInfo?.theme?.colors?.primary_color}`;
  } else {
    return `1px solid ${props?.storeInfo?.theme?.colors?.primary_color}`;
  }
};

// Here
export const VariantCtaContainer = styled.div`
  padding: 8px 20px;
  border-radius: ${(props) => roundnessCalculator(props?.storeInfo?.theme?.roundness)};
  border: 1px solid
    ${(props) =>
      borderColorAttributes(props?.isAvailable, props?.isSelected, props?.storeInfo)};
  ${(props) => props?.ml && `margin-left: ${props.ml}`};
  ${(props) => props?.mr && `margin-right: ${props.mr}`};
  width: fit-content;
  background: ${(props) => variantBackgroundColor(props)};
  color: ${(props) => (props?.isSelected ? 'blue' : '#dfdfdf')};
  margin-right: 14px;
  margin-top: 10px;
  cursor: pointer;

  &:hover {
    border: ${(props) => hoveredBorderState(props)};
  }
`;

export const VariantCtaText = styled.div`
  font-size: 14px;
  font-weight: 400;
  user-select: none;
  color: ${(props) => variantTextColor(props)};
`;
